import React,{useState,useEffect} from "react";
import API from "../../../utils/API";
import {FormGroup, Input, Label} from "reactstrap";

const ShareLimit = ({title,type,elementId,onClose}) => {

    const [typer,setTyper] = useState('')
    const [options,setOptions] = useState([])

    useEffect(() => {
        API.post('/admin/filter',{elementId:elementId,type:type,filterTitle:title}).then((response) => {

            setTyper(response.data.data.data.value || 'Exclusive')
            if (response.data.data.options) {
                setOptions(response.data.data.options)
            }
        });
    }, [title,type])

    const saveFilter = () => {
        API.put('/admin/filter',{elementId:elementId,type:type,filterTitle:title,data:{value:typer}}).then((response) => {
            onClose()
        });
    }

    return (
        <>
            <div className="row">
                <div className="col pt-2">
                    <h5>Filter by: {title}</h5>
                </div>
                <div className="col-auto text-right">
                    <button onClick={onClose} className="btn btn-outline-secondary mb-2">X</button><br/>
                </div>
            </div>
            <div className="mt-3">
                <div className="row">
                    <div className="col-6">
                        {options.length > 0 &&
                            <select className="form-control" value={typer} onChange={(e) => setTyper(e.target.value)}>
                                {
                                    options.map((option, index) => {
                                        return (
                                            <option value={option} key={index}>{option === 'Shared (Max 5 Buyers)' ? 'Shared (Max 5 Buyers) Default' : option}</option>
                                        )
                                    })
                                }
                            </select>
                        }
                    </div>
                </div>
            </div>
            <div className="mt-3 text-center">
                <button className="btn btn-primary" onClick={saveFilter}>Save</button>
            </div>
        </>
    )
}

export default ShareLimit;
